import styled from 'styled-components';

const Table = styled.div`
  width: 100%;
  display: table;
  border-collapse: collapse;
`;

export default Table;
